import { useQuery } from '@tanstack/react-query';
import { restaurantList } from '../../../api';
import { TRestaurantsResponse } from '../schemas/restaurant-schema';

const QUERY_KEY = 'restaurants';

// Get all restaurants
export const useGetRestaurants = () => {
  return useQuery({
    queryKey: [QUERY_KEY, 'all'],
    queryFn: async () => {
      const response = await restaurantList('?pageNum=1&pageSize=1000');
      return {
        restaurants: response?.data?.rows || [],
        total: response?.data?.total || 0,
      };
    },
  });
};

export const restaurantsService = {
  useGetRestaurants,
};
